<template>
  <div class="space-y-8">
    <div
      v-for="option in options"
      :key="option"
      data-label="orientation"
      :data-action="option"
      @click="selectOrientation(option)"
      class="flex items-center justify-between p-5 border border-grey-lighter cursor-pointer"
    >
      <div class="flex items-center space-x-8">
        <div class="w-14 h-14 flex justify-center items-center">
          <img v-show="option === 'landscape'" src="@/assets/icons/icon-landscape.svg?inline" class="w-full h-full" />
          <img v-show="option === 'portrait'" src="@/assets/icons/icon-portrait.svg?inline" class="w-full h-full" />
          <img v-show="option === 'square'" src="@/assets/icons/icon-square.svg?inline" class="w-full h-full" />
        </div>
        <span class="capitalize">
          {{ option }}
        </span>
      </div>
      <div>
        <span v-show="orientationActive(option)">
          <FaIcon :icon="['fal', 'check-square']" class="fa-lg text-primary" />
        </span>
        <span v-show="!orientationActive(option)">
          <FaIcon :icon="['fal', 'square']" class="fa-lg text-grey-light" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import ListingFilters from "@/lib/ListingFilters"

export default {
  name: "OrientationFilter",
  data() {
    return {
      options: ListingFilters.orientations,
    }
  },
  methods: {
    selectOrientation(orientation) {
      this.mergeFilter({
        orientations: this.orientationActive(orientation)
          ? this.orientations.filter((orient) => orient != orientation)
          : [...this.orientations, orientation],
      })
    },
    orientationActive(orientation) {
      return this.orientations.includes(orientation)
    },
    ...mapActions("filter", ["mergeFilter", "resetDimension"]),
  },
  computed: {
    ...mapState("filter", {
      orientations: (state) => state.filters.orientations,
    }),
  },
}
</script>
